import {useRuntimeConfig} from '#imports'

export function useCurrency () {
    const runtimeConfig = useRuntimeConfig()

    const currencyMap: Record<string, { locale: string, currencyCode: string }> = {
        '': {
            locale: 'de-DE',
            currencyCode: 'EUR'
        },
        'de': {
            locale: 'de-DE',
            currencyCode: 'EUR'
        },
        'ch': {
            locale: 'de-CH',
            currencyCode: 'CHF'
        },
        'fr': {
            locale: 'fr-FR',
            currencyCode: 'EUR'
        }
    }

    const formatPrice = function (price: number) {
        const urlLocale = runtimeConfig.public?.buildLanguage

        const formatter = new Intl.NumberFormat(currencyMap[urlLocale]?.locale, {
            style: 'currency',
            currency: currencyMap[urlLocale]?.currencyCode,
            minimumFractionDigits: 2
        })

        return formatter.format(price)
    }

    return {
        formatPrice
    }
}
